import React from 'react';
import {
  string, number, shape,
} from 'prop-types';
import DateTime from './DateTime';
import { connectCommonProps } from '../../../shared/utils/CommonPropsContext';

const I18nDateTime = ({ locale, date }) => <DateTime locale={locale} date={date} />;

I18nDateTime.propTypes = {
  locale: string,
  date: shape({
    time: number,
    timeZoneOffset: number,
  }),
};

export default connectCommonProps(I18nDateTime);
